<template>
  <b-dropdown variant="light" menu-class="keyword-dropdown" :disabled="loading">
    <template #button-content>
      <div v-if="selectedLanguage">
        {{ selectedLanguage.text }}
      </div>
      <div class="justify-content-between d-flex" v-else>
        <span class="mt-1">
          {{ $t('pages.keyword.keyword_input.language_placeholder') }}
        </span>
        <span v-if="invalid"> <i class="font-size-17 text-danger mdi mdi-alert-circle-outline"></i></span>
      </div>
    </template>

    <template v-for="(language, index) in languages">
      <b-dropdown-item v-if="!marketplace || language.active[marketplace]"
                       :key="index"
                       @click="setLanguage(language)"
                       :active="selectedLanguage === language"
      >
        {{ language.text }}
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
export default {
  name: "KeywordLanguage",
  props: {
    loading: {
      default: false
    },
    marketplace: {
      default: null
    },
    invalid: {
      default: false
    }
  },
  data() {
    return {
      selectedLanguage: '',
      languages: [
        {
          code: 'en',
          text: this.$t('pages.keyword.keyword_input.languages.en'),
          active: {
            ATVPDKIKX0DER: true,
            A2EUQ1WTGCTBG2: true,
            A2VIGQ35RCS4UG: true,
            A1PA6795UKMFR9: true,
            A1F83G8C2ARO7P: true,
            A21TJRUUN4KGV: true,
            A1805IZSGTT6HS: true,
            A17E79C6D8DWNP: true,
            A2NODRKZP88ZB9: true,
            A19VAU5U5O7RUS: true,
            A39IBJ37TRP1C6: true,
            A1VC38T7YXB528: true,
            ARBP9OOSHTCHU: true
          }
        },
        {
          code: 'es',
          text: this.$t('pages.keyword.keyword_input.languages.es'),
          active: {
            ATVPDKIKX0DER: true,
            A1AM78C64UM0Y8: true,
            A1RKKUPIHCS9HS: true
          }
        },
        {
          code: 'pt',
          text: this.$t('pages.keyword.keyword_input.languages.pt'),
          active: {
            A2Q3Y263D00KWC: true,
            A1RKKUPIHCS9HS: true
          }
        },
        {
          code: 'fr',
          text: this.$t('pages.keyword.keyword_input.languages.fr'),
          active: {
            A2EUQ1WTGCTBG2: true,
            A13V1IB3VIYZZH: true
          }
        },
        {
          code: 'ar',
          text: this.$t('pages.keyword.keyword_input.languages.ar'),
          active: {
            A2VIGQ35RCS4UG: true,
            A17E79C6D8DWNP: true,
            ARBP9OOSHTCHU: true
          }
        },
        {
          code: 'de',
          text: this.$t('pages.keyword.keyword_input.languages.de'),
          active: {
            A1PA6795UKMFR9: true
          }
        },
        {
          code: 'pl',
          text: this.$t('pages.keyword.keyword_input.languages.pl'),
          active: {
            A1PA6795UKMFR9: true,
            A1C3SOZRARQ6R3: true
          }
        },
        {
          code: 'cs',
          text: this.$t('pages.keyword.keyword_input.languages.cs'),
          active: {
            A1PA6795UKMFR9: true
          }
        },
        {
          code: 'nl',
          text: this.$t('pages.keyword.keyword_input.languages.nl'),
          active: {
            A1PA6795UKMFR9: true,
            A1805IZSGTT6HS: true
          }
        },
        {
          code: 'hi',
          text: this.$t('pages.keyword.keyword_input.languages.hi'),
          active: {
            A21TJRUUN4KGV: true
          }
        },
        {
          code: 'it',
          text: this.$t('pages.keyword.keyword_input.languages.it'),
          active: {
            APJ6JRA9NG5V4: true
          }
        },
        {
          code: 'sv',
          text: this.$t('pages.keyword.keyword_input.languages.sv'),
          active: {
            A2NODRKZP88ZB9: true
          }
        },
        {
          code: 'tr',
          text: this.$t('pages.keyword.keyword_input.languages.tr'),
          active: {
            A33AVAJ2PDY3EV: true
          }
        },
        {
          code: 'ja',
          text: this.$t('pages.keyword.keyword_input.languages.ja'),
          active: {
            A1VC38T7YXB528: true
          }
        },
        {
          code: 'zh-TW',
          text: this.$t('pages.keyword.keyword_input.languages.zhTW'),
          active: {
            A1VC38T7YXB528: true
          }
        },
        {
          code: 'zh-CN',
          text: this.$t('pages.keyword.keyword_input.languages.zhCN'),
          active: {
            A1VC38T7YXB528: true
          }
        }
      ]
    }
  },
  methods: {
    setLanguage(language) {
      this.selectedLanguage = language
      this.$emit('selected', this.selectedLanguage)
    }
  },
  watch: {
    marketplace() {
      this.selectedLanguage = null
    }
  }
}
</script>

<style scoped>
</style>